import { useEffect } from "react";

import { useOfertasDoDia } from "../useOfertasDoDia";

import { ajustarCarrinhoPdv } from "./carrinhoPdv";

// Liga a Campanha Inteligente num carrinho de atendente: busca as ofertas do
// cliente identificado naquele módulo e ajusta as linhas do carrinho.
// `produtos` (opcional): cadastro da tela — linha por quilo/litro conta 1 unidade.
export function useOfertasNoCarrinho({ clienteId, modulo, cart, setCart, campoPreco = "final_price", produtos = null }) {
  const ofertasDia = useOfertasDoDia({
    habilitado: !!clienteId,
    cliente: clienteId ? { id: clienteId } : null,
    modulo,
  });
  useEffect(() => {
    const { cart: novo, mudou } = ajustarCarrinhoPdv(cart, ofertasDia, clienteId || null, campoPreco, produtos);
    if (mudou) setCart(novo);
  }, [cart, ofertasDia, clienteId, setCart, campoPreco, produtos]);
  return ofertasDia;
}
